import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border p-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "A",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "A",
      name: "interior-radio",
      value: "A"
    }),
    /*#__PURE__*/_createTextVNode("【A】キズ")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "K",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "K",
      name: "interior-radio",
      value: "K"
    }),
    /*#__PURE__*/_createTextVNode("【K】コゲ")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "S",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "S",
      name: "interior-radio",
      value: "S"
    }),
    /*#__PURE__*/_createTextVNode("【S】スレ")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "SI",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "SI",
      name: "interior-radio",
      value: "SI"
    }),
    /*#__PURE__*/_createTextVNode("【SI】シミ")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "W",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "W",
      name: "interior-radio",
      value: "W"
    }),
    /*#__PURE__*/_createTextVNode("【W】割れ")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "N",
    class: "text-nowrap me-2"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      id: "N",
      name: "interior-radio",
      value: ""
    }),
    /*#__PURE__*/_createTextVNode("【N】無し")
  ])
], -1)
const _hoisted_3 = {
  class: "w-100",
  style: {"background-image":"url(/images/check_02.png)","background-size":"100% 100%","background-repeat":"no-repeat"}
}
const _hoisted_4 = ["id", "data-row", "data-col", "onMousedown", "onTouchstart"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " 閉じる ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BsModal = _resolveComponent("BsModal")!

  return (_openBlock(), _createBlock(_component_BsModal, {
    ref: "interiorCheckModalRef",
    class: "fade"
  }, {
    header: _withCtx(() => []),
    footer: _withCtx(() => [
      _hoisted_5,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setInteriorData()), ["prevent"])),
        onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setInteriorData()), ["prevent"]))
      }, " 保存 ", 32)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interiorCheckRow, (m) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row d-flex flex-nowrap px-3",
              key: m
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interiorCheckCol, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  id: 'interior_modal_' + m + '_' + n,
                  class: "col d-flex align-items-center justify-content-center interior_cell border",
                  style: {"height":"90px","font-size":"150%"},
                  "data-row": m,
                  "data-col": n,
                  onMousedown: _withModifiers(($event: any) => (_ctx.setInteriorCheck(m, n)), ["prevent"]),
                  onTouchstart: _withModifiers(($event: any) => (_ctx.setInteriorCheck(m, n)), ["prevent"])
                }, null, 40, _hoisted_4))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}